import { Artifact } from 'data/generated/graphql';

export type RouteConfig = { path: string; name: string };

/**
 * Maps each Artifact type to its corresponding route configuration.
 * Used for navigation, redirects, and mobile sidebar.
 */
export const ARTIFACT_ROUTE_CONFIGS: Record<Artifact, RouteConfig> = {
  [Artifact.Page]: { path: '', name: 'Pages' },
  [Artifact.Collection]: { path: '/collections', name: 'Collections' },
  [Artifact.OffPlatform]: { path: '/off-platform', name: 'Off-Platform' },
  [Artifact.ItpIssue]: { path: '/issues', name: 'ITP Issues' },
  [Artifact.Newsletter]: { path: '/newsletters', name: 'Newsletters' },
  [Artifact.Banner]: { path: '/banners', name: 'Banners' },
  [Artifact.MultiCollection]: { path: '/multicollection', name: 'Newswires' },
  [Artifact.Layout]: { path: '/site-config/layouts', name: 'Layouts' }
};

/**
 * Priority order for feature navigation/redirects.
 * Matches the order displayed in the UCS subnav.
 */
export const ARTIFACT_PRIORITY_ORDER: Artifact[] = [
  Artifact.Page,
  Artifact.Collection,
  Artifact.OffPlatform,
  Artifact.ItpIssue,
  Artifact.Newsletter,
  Artifact.Banner,
  Artifact.MultiCollection,
  Artifact.Layout
];

/**
 * Artifacts that require publisher role to access.
 */
export const PUBLISHER_REQUIRED_ARTIFACTS: Artifact[] = [
  Artifact.Page,
  Artifact.ItpIssue,
  Artifact.Newsletter,
  Artifact.Banner,
  Artifact.MultiCollection
];
